export const PASSLY_PORTAL_CLIENT_ID = 'my:passly:portal';

export const OTP_PASSCODE_LENGTH = 8;
